import DownSvg from 'assets/svg/Down';
import useFetchAttributeNamesOnly from 'hooks/Filter/useFetchAttributeNamesOnly';
import React, { FC, useCallback, useContext, useEffect, useRef, useState } from 'react';
import Loader from './Loader';
import useFetchAttributeNamesAlt from 'hooks/Filter/useFetchAttributeNamesAlt';
import _ from 'lodash';
import { FilterContextData } from 'contexts/FilterContext';
import { UserContext } from 'contexts/ConfigContext';
import { getConfig } from 'utils/helperMethods';
import InfiniteScroller from './InfiniteScroller';
import { useOnClickOutside } from 'hooks/general/useOnOutsideClick';
import { defaultApplyFilter } from 'components/pages/GrowthAnalysis';
import { useApplyFilterMutation } from 'hooks/general/useApplyFilterMutation';

interface Props {
    attributeType: any;
    options: any;
    offset: any;
    loading: boolean;
    disabled?: boolean;
    count: number;
    onCheckboxChange: Function;
    fetchDropdownData: (arg1: boolean, arg2: number, arg3: string) => any;
    setApplyFilterTempLoading: Function;
    search: string;
    setSearch: Function;
    dropdownValue: any;
}

const dropdownWrapperId = 'dropdown-v2-wrapper-id';

const PricePointMultiSelectionDropdownV2: FC<Props> = ({
    loading,
    attributeType,
    onCheckboxChange,
    options,
    count,
    offset,
    fetchDropdownData,
    setApplyFilterTempLoading,
    disabled,
    search,
    setSearch,
    dropdownValue,
}) => {
    const { idForRestOfComponent } = useContext(FilterContextData);
    const { appConfig } = useContext(UserContext);
    const globalFilterConfig = getConfig('globalFilter', appConfig);

    const [showPopup, setShowPopup] = useState(false);
    // const [search, setSearch] = useState('');
    const [unCheckedOptions, setUnCheckedOptions] = useState<any>({});
    const outsideClickRef = useRef<any>(null);
    const checkedOptionsRef = useRef<any>({});
    const onClickOfDropdown = () => {
        setShowPopup(!showPopup);
    };

    useEffect(() => {
        if (showPopup && options && Array.isArray(options) && offset.current === 0) {
            const wrapperElem = document
                .getElementById(dropdownWrapperId)
                ?.getElementsByClassName('infinite-scroll-component')[0];
            if (wrapperElem) {
                wrapperElem.scrollTo(0, 0);
            }
        }
    }, [showPopup]);

    useEffect(() => {
        // if (showPopup && idForRestOfComponent) {
        //     offsetRef.current = 0;
        //     fetchAttributeName(search);
        // }
        if (options && Array.isArray(options) && !search) {
            const tempCheckedOptions: any = { ...unCheckedOptions };
            checkedOptionsRef.current = {};
            options?.map((item) => {
                if (item?.isChecked && !(item?.attributeExId in tempCheckedOptions))
                    checkedOptionsRef.current[item?.attributeExId] = item;
                if (!item?.isChecked && !(item?.attributeExId in tempCheckedOptions))
                    tempCheckedOptions[item?.attributeExId] = item;
            });
            if (offset.current === 0) onCheckboxChange(tempCheckedOptions);
            setUnCheckedOptions(tempCheckedOptions);
            // setUncheckedOptions(tempUncheckedOptions)
        }
        if (search) {
            // checkedOptionsRef.current = {};
            // setUnCheckedOptions({});
        }
        if (offset.current > 0 && options && Array.isArray(options)) setApplyFilterTempLoading(false);
    }, [options]);

    useEffect(() => {
        setUnCheckedOptions(() => {
            return {};
        });
        checkedOptionsRef.current = {};
    }, [dropdownValue]);

    //close expanded attribute name on clicking outside
    const clickOutsideHandler = useCallback(
        (event: any) => {
            if (showPopup) {
                setShowPopup(false);
            }
        },
        [showPopup],
    );
    useOnClickOutside(outsideClickRef, clickOutsideHandler);

    //trigger by the infinite scroll component
    const infiniteScrollOnNext = (loading: boolean) => {
        if (!loading) {
            offset.current = offset.current + globalFilterConfig?.limit;
            fetchDropdownData(loading, offset.current, search);
        }
    };

    function checkboxOnChangeHandler(isChecked: boolean, item: any) {
        //remove item from checked options if user is unchecking
        let temp = { ...unCheckedOptions };
        let checkedTemp = { ...checkedOptionsRef.current };
        if (isChecked) {
            checkedTemp = { ...checkedOptionsRef.current, [item?.attributeExId]: item };
            delete temp[item?.attributeExId];
        } else {
            if (Object.keys(checkedOptionsRef.current).length <= 1) return;
            delete checkedTemp[item?.attributeExId];
            temp = { ...unCheckedOptions, [item?.attributeExId]: item };
        }
        checkedOptionsRef.current = checkedTemp;
        onCheckboxChange(temp);
        setUnCheckedOptions(temp);
    }

    function placeholder() {
        const keys = Object.keys(checkedOptionsRef.current);
        if (keys?.length === 1) {
            return keys[0];
        }
        if (keys?.length === 0) return 'Select Variable';
        return 'Multi Selection';
    }

    //memo debounce function
    const deBouncedSearch = useCallback(_.debounce(fetchDropdownData, 1000), [attributeType, idForRestOfComponent]);
    return (
        <div id={dropdownWrapperId} className="inline-block relative" ref={outsideClickRef}>
            <div className="dropdown-height px-2 rounded border border-purpleFont border-0 dropdown-width-multi-select flex items-center gap-1 justify-between">
                <input
                    // disabled
                    style={{ whiteSpace: 'nowrap', width: '100%', overflow: 'hidden', textOverflow: 'ellipsis' }}
                    type="text"
                    className="bg-white font-xs focus:outline-none placeholder-black"
                    onChange={(e) => {
                        offset.current = 0;
                        setSearch(e.target.value);
                        deBouncedSearch(loading, offset.current, e.target.value);
                    }}
                    placeholder={placeholder()}
                    value={search}
                />
                {/* <div
                    className="absolute cursor-pointer inset-0"
                    onClick={(e) => {
                        onClickOfDropdown();
                    }}
                ></div> */}
                <span
                    className="z-10 font-normal cursor-pointer text-right text-slate-300 text-base w-4"
                    onClick={() => onClickOfDropdown()}
                >
                    <DownSvg />
                </span>
            </div>
            <div
                className={`bg-white dropdown-menu absolute z-[20] text-primary w-full shadow-l drop-shadow-lg rounded-b ${
                    showPopup ? `` : `hidden`
                }`}
            >
                <InfiniteScroller
                    data={options}
                    loading={loading}
                    hasMore={options?.length < count}
                    height={128}
                    onNext={() => infiniteScrollOnNext(loading)}
                >
                    {loading && offset.current === 0 && <div className="absolute inset-0">{<Loader />}</div>}
                    <ul style={{ opacity: loading ? 0.3 : 1 }}>
                        {!options?.length && !loading && (
                            <div className="flex justify-center items-center h-full w-full mt-6">Not Found</div>
                        )}
                        {options?.map((item: any, index: number) => {
                            return (
                                <li key={index} className={'mx-3 mt-2'}>
                                    <div className="text-base flex gap-2 items-center" key={index}>
                                        <input
                                            disabled={disabled}
                                            type={'checkbox'}
                                            className={'checkbox-size accent-purpleFont cursor-pointer'}
                                            value={item?.attributeExId}
                                            checked={
                                                checkedOptionsRef.current
                                                    ? item?.attributeExId in checkedOptionsRef.current
                                                    : false
                                            }
                                            onChange={(e) => {
                                                checkboxOnChangeHandler(e.target.checked, item);
                                            }}
                                            //disabled={!item?.isActive}
                                        />
                                        <span style={{ wordBreak: 'break-all' }} className="font-xs">
                                            {item?.attributeExId}
                                        </span>
                                    </div>
                                </li>
                            );
                        })}
                    </ul>
                </InfiniteScroller>
            </div>
        </div>
    );
};

export default PricePointMultiSelectionDropdownV2;
